import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Modal , Menu, Button, Row, Col, Input, Form, Icon, message,Card, Upload, notification} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { history } from '../../container/History';
import * as actions from '../../actions/index';

class AlumniProgramSupport extends Component {
  constructor(props){
    super(props)
    this.state = {
      ComingSoon : false,
    }
  }

  static propTypes = {
    location: PropTypes.object.isRequired
  }

  show_ComingSoon = () => {
    this.setState({
      ComingSoon: true
    })
    history.push('/need-help-alumni-program-support')
  }

  hide_ComingSoon = () => {
    this.setState({
      ComingSoon: false
    })
    history.push('/need-help-alumni-program-support')
  }

  render () {
    const { location } = this.props;
    return (
      <div>
        <LayoutHeader />

        <Menu mode="horizontal" selectedKeys={[location.pathname]} defaultSelectedKeys={['/']} style={{ alignItems: "end", display: "Flex", justifyContent: "end"  }}>
          <Menu.Item key="/alumni-dashboard"> 
            <NavLink to="/alumni-dashboard">
              <button className='Need-help-action'>CLOSE <i class="fa fa-window-close" aria-hidden="true"></i></button>  
            </NavLink>
          </Menu.Item>
        </Menu>

        <div className='Alumni-NeedHelp-Container'>
          <div className='Alumni-NeedHelp-Program-Support'>
            The <Button onClick={() => this.show_ComingSoon()} type="link" className='Alumni-NeedHelp-Form-Link' > Spark Alumni Support </Button> team
            is that group of leaders who manage and support the Scouting Alumni Association's mission, programs and services.
          </div>
        </div>

        <Modal
            className='coming-soon-modal'
            style={{ width: '600px' }}
            title={false}
            footer={false}
            visible={this.state.ComingSoon}
            centered
            onCancel={() => this.hide_ComingSoon()}
        >
            <div className="center">
                <div className='Coming-Soon-Message'>
                    Coming Soon!
                </div>
                <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                        <div className='step-container margin-top-20' >
                            <Button type="primary" className='close-comingsoon-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                this.hide_ComingSoon();
                            }} htmlType='submit'>CLOSE </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>

      </div>
      
    )
  }
}

function mapStateToProps(state) {
  return {
    isadmin: state.isadminreducer.isadmin,
  }
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(AlumniProgramSupport));


// WEBPACK FOOTER //
// ./src/components/AlumniHelp/AlumniProgramSupport.js